import React, { useState } from "react";
import { StyleSheet, View, Pressable } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";
import { useAppConfig } from "../../../AppConfigProvider";

interface TabData {
  key: string;
  title: string;
}

interface CourseTabNavigatorProps {
  tabData: TabData[];
  activeTab: string;
  onTabPress: (tabKey: string) => void;
}

const CourseTabNavigator: React.FC<CourseTabNavigatorProps> = ({ tabData, activeTab, onTabPress }) => {
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);
  const appConfig = useAppConfig();
  const activeTabColor = appConfig.primaryColor;

  return (
    <View style={styles.navBar}>
      {tabData.map((tab) => {
        const isActive = activeTab === tab.key;
        const isHovered = hoveredTab === tab.key;

        return (
          <Pressable
            key={tab.key}
            style={[styles.tab, isActive && { borderBottomColor: activeTabColor }]}
            onPress={() => onTabPress(tab.key)}
            onHoverIn={() => setHoveredTab(tab.key)}
            onHoverOut={() => setHoveredTab(null)}>
            <CustomText
              text={tab.title}
              size="s"
              weight="medium"
              style={[
                styles.tabText,
                isActive
                  ? [styles.activeTabText, { color: activeTabColor }]
                  : [styles.inactiveTabText, isHovered && styles.hoveredTabText],
              ]}
            />
          </Pressable>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  navBar: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    paddingHorizontal: 16,
    paddingTop: 8,
    gap: 4,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
  },
  tab: {
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 14,
    borderBottomWidth: 2,
    borderBottomColor: "transparent",
    marginBottom: -1,
  },
  tabText: {
    fontSize: 14,
    fontWeight: "500",
  },
  activeTabText: {
    fontWeight: "500",
  },
  inactiveTabText: {
    color: "#6B7280",
  },
  hoveredTabText: {
    color: "#1E293B",
  },
});

export default CourseTabNavigator;
